import React from 'react';
import { Typography } from '@mui/material';

type OverviewHeaderProps = {
  text: string;
  bold?: boolean;
};

export const OverviewHeader: React.FC<OverviewHeaderProps> = ({ text, bold = false }) => (
  <Typography
    sx={{
      color: 'var(--color-type-secondary)',
      marginBottom: 3,
      fontWeight: !bold ? 600 : 700,
      fontSize: '16px',
    }}
  >
    {text}
  </Typography>
);
